import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { signInPageModule } from './signInPage';
import networkFoundationPlugin from './plugins/networkFoundation';
import dnsRecordPlugin from './plugins/dnsRecord';
import gmailDelegationPlugin from './plugins/gmailDelegation';
import staticSitePlugin from './plugins/staticSite';
import staticSitePromotePlugin from './plugins/staticSitePromote';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    signInPageModule,
    networkFoundationPlugin,
    dnsRecordPlugin,
    gmailDelegationPlugin,
    staticSitePlugin,
    staticSitePromotePlugin,
  ],
});
